<home-slider [slides]='slides'></home-slider>

<app-categoties-header></app-categoties-header>
<app-categories-content></app-categories-content>
<app-footer ></app-footer>